import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsProjectSchemesGrid: [],
    workDocsProjectSchemesAll: [],
    workDocsProjectSchemesShow: null,
    pageData: null,
    uploadSchemesProgress: 0,
  },
  mutations: {
    setWorkDocsProjectSchemesGrid(state, payload) {
      state.workDocsProjectSchemesGrid = payload
    },
    setWorkDocsProjectSchemesAll(state, payload) {
      state.workDocsProjectSchemesAll = payload
    },
    setWorkDocsProjectSchemesShow(state, payload) {
      state.workDocsProjectSchemesShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setUploadSchemesProgress(state, payload) {
      state.uploadSchemesProgress = payload
    },
    setDefaultSchemes(state) {
      ;(state.workDocsProjectSchemesGrid = []), (state.workDocsProjectSchemesAll = [])
    },
  },
  getters: {
    workDocsProjectSchemesGrid: (state) => {
      return state.workDocsProjectSchemesGrid
    },
    workDocsProjectSchemesAll: (state) => {
      return state.workDocsProjectSchemesAll
    },
    workDocsProjectSchemesShow: (state) => {
      return state.workDocsProjectSchemesShow
    },
    pageData: (state) => {
      return state.pageData
    },
    uploadSchemesProgress: (state) => {
      return state.uploadSchemesProgress
    },
  },
  actions: {
    onWorkDocsProjectSchemesGrid({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/project-scheme/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&order[]=name:asc',
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectSchemesGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesAll({ commit, rootState }, project_id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/project-scheme/grid?limit=0&filter[]=project_id:' +
            project_id +
            '&order[]=created_at:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectSchemesAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-scheme/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectSchemesShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-scheme',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-scheme',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-scheme/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectSchemesUploadFiles({ commit, rootState }, { data }) {
      return new Promise((resolve, reject) => {
        let progress = 0
        axios({
          url: rootState.apiDomain + '/api/uploadfile',
          data: data,
          method: 'POST',
          onUploadProgress: (e) => {
            progress = Math.round((e.loaded * 98) / e.total)
            commit('setUploadSchemesProgress', progress)
          },
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
